import axiosInstance from "./axiosInstance";
import { getCookie } from "./axiosInstance";
import axios from "axios";

//Εγγραφή χρήστη , χρησιμοποιείται για να στείλει τα στοιχεία του χρήστη στο backend και να τον εγγράψει
export const signupUser = async (userData) => {
    try {
        const response = await axiosInstance.post("/user/signup/", userData);//Στέλνουμε τα στοιχεία του χρήστη στο backend για να τον εγγράψει
        return response;
    } catch (error) {
        if (error.response?.data) {
            //Ρίχνουμε σφάλμα αν δεν υπάρχει το access token
            throw new Error(error.response.data.error || error.response.data.message || "Signup failed");
        }
        throw error;
    }
};

//Είσοδος χρήστη , χρησιμοποιείται για να στείλει τα στοιχεία του χρήστη στο backend και να τον συνδέσει
const loginUser = async (username, password) => {
    try {
        const response = await axiosInstance.post("/user/login/", {
            username,
            password
        });

        // Success case
        const { access, refresh } = response.data;

        if (access) {
            localStorage.setItem("access", access);
            if (refresh) {
                localStorage.setItem("refresh", refresh);
            }
            axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${access}`;
        }

        return response;
    } catch (error) {
        // ✅ Καθαρισμός tokens
        localStorage.removeItem("access");
        localStorage.removeItem("refresh");

        // ✅ Επιστρέφουμε το error response, ΔΕΝ το ξαναπετάμε!
        throw error; // Το throw είναι οκ, το Login component το πιάνει με try-catch
    }
};

// Συνάρτηση για να πάρει το CSRF token από τον server
export const getCsrfToken = async () => {
    try {
        // 1. Πρώτα προσπαθούμε να βρούμε το token από τα cookies
        let token = getCookie("csrftoken");
        if (token) {
            return token;
        }

        // 2. Αν δεν υπάρχει, ζητάμε ένα GET request στον server
        await axiosInstance.get("/user/login/", {
            withCredentials: true // Χρειάζεται για να στείλουμε τα cookies
        });

        // 3. Ξανακοιτάμε στα cookies
        token = getCookie("csrftoken");
        if (!token) {
            throw new Error("CSRF token not found in cookies");
        }

        return token;
    } catch (error) {
        throw new Error("Failed to fetch CSRF token");
    }
};

// Προσθήκη στο user_authentication.js
export const requestPasswordReset = async (email) => {
    try {
        const response = await axiosInstance.post(
            '/user/password-reset/',  // Χρησιμοποιούμε το axiosInstance με το σωστό baseURL
            { email: email },
            {
                headers: {
                    'Content-Type': 'application/json',
                }
            }
        );
        return response;
    } catch (error) {
        console.error('Password reset request error:', error);
        throw error;
    }
};

export const resetPassword = async (uid, token, newPassword) => {
    try {
        const response = await axiosInstance.post(
            '/user/password-reset-confirm/',
            {
                uid: uid,
                token: token,
                new_password: newPassword
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                }
            }
        );
        return response;
    } catch (error) {
        console.error('Reset password error:', error);
        throw error;
    }
};

// Πρόσθεσε αυτό στο τέλος του αρχείου
export const googleLogin = async (credential) => {
    try {
        const response = await axiosInstance.post("/user/google/", {
            credential: credential,
        });
        return response;
    } catch (error) {
        throw error;
    }
};

export { loginUser }